// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"KL-z","carouselContainer":"LL-z"};